
























import { Vue, Component, Prop } from "vue-property-decorator";
import { Dropdown, Input } from "@brankas/web-ui";

@Component({
  components: {
    Dropdown,
    Input,
  },
})
export default class FilterCard extends Vue {
  @Prop({ type: Object, default: () => ({}) }) option: any;
  @Prop({ type: String, default: () => ({}) }) value: string;

  onChange(value: any, name: string) {
    this.$emit("input", { value, name });
  }

  // Methods
  submitFilter() {
    this.$emit("filter");
  }

  dropdownFilter(value: any, name: string) {
    this.onChange(value, name);
    this.submitFilter();
  }
}
